import SystemFooter from "default/components/SystemFooter";

const PotionFooter = () => {
  return (
    <SystemFooter
      contentLinks={[
        ["my_page", "mypage"],
        ["quests", "quests"],
        ["purchase_ticket", "tickets"],
        ["exchange_money", "exchange_money"],
        ["payment", "payment"],
      ]}
    />
  );
};

export default PotionFooter;
